<template>
  <div class="sub flex center gaps">
    <!-- 件数表示 -->
    <div class="box">
      <template v-if="total">
        {{ total }}
        <small>件中、</small>
        {{ computedOrderFrom }}〜{{ computedOrderTo }}
        <small>件を表示しています</small>
      </template>
      <template v-else>
        {{ total }} <small>件</small>
      </template>
    </div>

    <!-- スペース埋め -->
    <div class="box grow" />

    <!-- 絞り込み解除 -->
    <div class="box">
      <el-button
        v-if="isFiltered"
        icon="el-icon-close"
        size="mini"
        type="text"
        plain
        round
        @click="$emit('onClearFilterConditions')"
      >
        条件をクリア
      </el-button>
    </div>

    <!-- 絞り込み -->
    <div class="box">
      <el-button
        icon="el-icon-search"
        size="mini"
        :type="isFiltered ? 'primary' : 'plain'"
        :plain="isFiltered"
        round
        @click="localIsShowFilterModal = true"
      >
        絞り込み
      </el-button>

      <slot name="filterModal" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminHomeSub",
  props: {
    total: Number,
    currentPage: Number,
    pageSize: Number,
    isShowFilterModal: Boolean,
    isExporting: Boolean,
    isFiltered: Boolean,
  },
  data () {
    return {
    };
  },
  computed: {
    computedOrderFrom () {
      const {
        currentPage,
        pageSize,
      } = this;

      return (currentPage - 1) * pageSize + 1;
    },
    computedOrderTo () {
      const {
        total,
        currentPage,
        pageSize,
      } = this;

      return Math.min(currentPage * pageSize, total);
    },
    localIsShowFilterModal: {
      get () {
        return this.isShowFilterModal;
      },
      set (value) {
        this.$emit("update:isShowFilterModal", value);
      },
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.sub {
  padding: 3px 16px 12px 15px;
}
</style>
